import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OPTIMIZELY_ENABLED = createFcmDetails('optimizely_enabled', {
	owner: 'Site Platform',
	context: 'Optimizely experiments',
	description: 'Used to toggle Optimizely on the platform',
	import: false,
});
